import {
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector
} from 'react-redux';

import { ENABLE_DEBUGGING } from '../../src/appsettings';
import authInterceptor from 'src/core/authIntercepter';
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import signalRMiddleware from 'src/core/signalRMiddleware';

const store = configureStore({
  reducer: rootReducer,
  devTools: ENABLE_DEBUGGING,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([authInterceptor, signalRMiddleware])
});

export const useSelector = useReduxSelector;

export const useDispatch = () => useReduxDispatch();

export default store;
